import { NgModule, ErrorHandler } from "@angular/core";
import { BrowserModule, Title } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { CalendarModule } from "primeng/components/calendar/calendar";

import { AppComponent } from "./app.component";
import { PaymentModule } from "./payment/payment.module";
import { TpaModule } from "./tpa/tpa.module";
import { VehiclesModule } from "./vehicles/vehicles.module";
import { CabinsModule } from "./cabins/cabins.module";
import { CabinAllocationsModule } from "./cabin-allocations/cabin-allocations.module";
import { AgentModule } from "./agent/agent.module";
import { SbEvent } from "./shared/sb-event.emitter";
import { SharedModule } from "./shared/shared.module";
import { SbErrorHandler } from "./error.handler";
import { BookingsModule } from "./amendment/bookings/bookings.module";
import { MealsModule } from "./meals/meals.module";
import { ComponentDemoModule } from "./shared/component-demo/component-demo.module";
import { TravelModule } from "./travel/travel.module";
import { PassengersModule } from "app/passengers/passengers.module";
import { FaresModule } from "./fares/fares.module";
import { EnvironmentService } from "app/environment.service";
import { UIModule } from "app/shared/UI.module";
import { FormBuilderTyped } from "app/shared/form-builder-typed";
import { ErrorPageComponent } from "app/error-page/error-page.component";
import { NotFoundComponent } from "app/not-found/not-found.component";
import { CabinFaresModule } from "./cabin-fares/cabin-fares.module";
import { JsonInterceptor } from "app/shared/json-interceptor";
import { TrackingService } from "./shared/tracking/tracking.service";
import { DFDSUIModule } from "./shared/dfds-ui.module";
import { TestErrorComponent } from "./test-error/test-error.component";
import { OktaService } from "./okta/okta.service";
import { OktaProviderComponent } from './okta/okta.provider'
import { IEOverlayComponent } from './shared/ie-overlay/ie-overlay.component'
import { PetsModule } from './pets/pets.module';
import { OktaState } from './okta/okta-state'

const ROUTES: Routes = [
    { path: "error/sbw", component: ErrorPageComponent },
    { path: "testerror", component: TestErrorComponent },
    { path: "**", component: NotFoundComponent },
];

@NgModule({
    imports: [
        ComponentDemoModule,
        BrowserModule,
        FormsModule,
        PaymentModule,
        TpaModule,
        VehiclesModule,
        CabinsModule,
        AgentModule,
        UIModule,
        DFDSUIModule,
        SharedModule,
        MealsModule,
        BookingsModule,
        TravelModule,
        PassengersModule,
        CalendarModule,
        FaresModule,
        CabinAllocationsModule,
        CabinFaresModule,
        BrowserAnimationsModule,
        PetsModule,
        RouterModule.forRoot(ROUTES, { useHash: false }),
    ],
    declarations: [
        AppComponent,
        ErrorPageComponent,
        NotFoundComponent,
        TestErrorComponent,
        TestErrorComponent,
        OktaProviderComponent,
        IEOverlayComponent,
    ],
    providers: [
        OktaService,
        OktaState,
        SbEvent,
        Title,
        EnvironmentService,
        TrackingService,
        FormBuilderTyped,
        { provide: ErrorHandler, useClass: SbErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: JsonInterceptor, multi: true },
    ],

    bootstrap: [AppComponent],
})
export class AppModule { }
